import React from 'react';
import Dialog from '../../../core/layout/Dialog';
import PropTypes from 'prop-types';
import FormButtons from '../../../core/form/FormButtons';
import Row from '../../../core/layout/Row';
import get from 'lodash/get';
import TextInput from '../../../core/form/TextInput';
import Column from '../../../core/layout/Column';
import LocalFileInput from '../../../core/form/LocalFileInput';

const FileRepositoryCategoryModal = (props) => {
  return (
    <Dialog
      title={props.isEditing ? 'Edit Category' : 'Add Category'}
      isOpen={props.isModalOpen}
      onClose={props.onClose}
      onCancel={props.onClose}
      width="30%"
      closeable
      actions={null}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.onSubmit();
        }}
      >
        <Row>
          <Column size={24}>
            <TextInput
              floatingLabel
              fullWidth
              required
              disabled={props.submitting || props.loading || props.disabled}
              label="Title"
              value={get(props.values, 'title', '')}
              onChange={(value) => props.onChange('title', value)}
              errorText={get(props.errors, 'title', '')}
            />
          </Column>
        </Row>
        <Row>
          <Column size={24}>
            <TextInput
              floatingLabel
              fullWidth
              disabled={props.submitting || props.loading || props.disabled}
              label="Description"
              value={get(props.values, 'description', '')}
              onChange={(value) => props.onChange('description', value)}
              errorText={get(props.errors, 'description', '')}
            />
          </Column>
        </Row>
        <Row>
          <LocalFileInput
            value={get(props.values, 'iconFile', null)}
            onChange={(value) => props.onChange('iconFile', value)}
            label="Icon"
            accept="image"
            disabled={props.submitting || props.loading || props.disabled}
          />
        </Row>
        <FormButtons
          confirmLabel={`${props.isEditing ? 'Update' : 'Create'} Category`}
          isDisabled={props.submitting || props.loading || props.disabled}
          isSubmitting={props.submitting}
          onReset={props.onReset}
        />
      </form>
    </Dialog>
  );
};

FileRepositoryCategoryModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
};

FileRepositoryCategoryModal.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
};

export default FileRepositoryCategoryModal;
